import React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { formatUserName, getInitials } from '../../../utils';
import { EmptyValue } from './detailSection.component';

type UserLike = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
};

interface UserDisplayProps {
  user?: UserLike | null;
  /** Shown after the name, e.g. a chip saying where the user came from. */
  suffix?: React.ReactNode;
  /** Text size - `small` for the metadata footer. */
  size?: 'small' | 'medium';
}

/** A person shown in a detail view: initials avatar and name (or email). */
export const UserDisplay = ({ user, suffix, size = 'medium' }: UserDisplayProps) => {
  const name = formatUserName(user);
  if (!name) return <EmptyValue />;

  const avatarSize = size === 'small' ? 20 : 24;

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
      <Avatar sx={{ width: avatarSize, height: avatarSize, fontSize: avatarSize * 0.45, fontWeight: 700 }}>
        {getInitials(name)}
      </Avatar>
      <Typography
        variant={size === 'small' ? 'body2' : 'subtitle1'}
        component="span"
        title={user?.email ?? undefined}
        sx={{ wordBreak: 'break-word' }}
      >
        {name}
      </Typography>
      {suffix}
    </Box>
  );
};
